import { render, staticRenderFns } from "./DataComponent.vue?vue&type=template&id=bbd68018&scoped=true"
import script from "./DataComponent.vue?vue&type=script&lang=js"
export * from "./DataComponent.vue?vue&type=script&lang=js"
import style0 from "./DataComponent.vue?vue&type=style&index=0&id=bbd68018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd68018",
  null
  
)

export default component.exports